import get from 'lodash.get';
import KeycloakClient from '../clients/shared/KeycloakClient';
import { FETCH_INTERCOM_INFO } from '../actionTypes/shared/apiActionTypes';

export const initialState = {
    data: {},
    isInfoFetched: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_INTERCOM_INFO.SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.response,
                    rootInstitutions: get(action.response, 'rootInstitutions', []),
                    products: get(action.response, 'products', []),
                    userEmail: KeycloakClient.getUserEmail(),
                    name: KeycloakClient.getUserName(),
                },
                isInfoFetched: true,
            };
        case FETCH_INTERCOM_INFO.ERROR:
            return { ...state, error: action.error };
        default:
            return state;
    }
};

const getIntercomData = state => state.data;

const isIntercomInfoFetched = state => state.isInfoFetched;

export const selectors = {
    getIntercomData,
    isIntercomInfoFetched,
};
